<template>
  <div class="p-grid p-jc-center p-ac-center" style="padding:50px;height:600px">
    <div class="p-col-12 p-md-6 p-lg-4">
      <Card>
        <template slot="header">
          <ProgressBar mode="indeterminate" style="height: 1px" v-if="loading" />
        </template>
        <template slot="content">
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
              <i class="pi pi-user"></i>
            </span>
            <span class="p-float-label">
              <InputText id="username" type="text" v-model.trim="username" />
              <label for="username">{{ $t("messages.username") }}</label>
            </span>
          </div>
          <div class="p-inputgroup p-mt-5">
            <span class="p-inputgroup-addon">
              <i class="pi pi-lock"></i>
            </span>
            <span class="p-float-label">
              <InputText id="password" type="password" v-model.trim="password" />
              <label for="password">{{ $t("messages.password") }}</label>
            </span>
          </div>
        </template>
        <template slot="footer">
          <div class="containerFooter">
            <Button :label="$t('messages.login')" @click="acceder()" :loading="loading" name="login" />
            <span class="linkResetPassword" @click="solicitarCambioDialog = true">{{ $t("messages.forgotPassword") }}</span>
          </div>
        </template>
      </Card>
    </div>
    <Dialog :visible="solicitarCambioDialog" :style="{ width: '450px' }" :header="$t('messages.writeYourEmail')"
      :modal="true" :closable="false">
      <div class="confirmation-content">
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">
            <i class="mdi mdi-email"></i>
          </span>
          <span class="p-float-label">
            <InputText id="email" type="text" v-model.trim="email" />
            <label for="username">{{ $t("messages.email") }}</label>
          </span>
        </div>
      </div>
      <template #footer>
        <Button :label="$t('messages.cancel')" icon="pi pi-times" class="p-button-text"
          @click="solicitarCambioDialog = false" name="cancelar" />
        <Button :label="$t('messages.accept')" icon="pi pi-check" class="p-button-text" @click="solicitarCambio"
          name="aceptar" />
      </template>
    </Dialog>
  </div>
</template>

<script>
//components PRIME
import { mapGetters, mapMutations } from "vuex";
import AuthService from "../service/auth.service";
export default {
  metaInfo: {
    title: 'Login - QualityCare',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Login - QualityCare',
        content: 'Login de usuario en QualityCare',
      },
    ],
  },
  name: "login",
  data() {
    return {
      authService: null,
      loading: false,
      password: "",
      username: "",
      solicitarCambioDialog: false,
      email: null
    };
  },
  created() {
    this.authService = new AuthService();
  },
  methods: {
    ...mapMutations(["setDataUser"]),
    acceder() {
      this.loading = true;
      if (this.username == "" || this.password == "") {
        this.loading = false;
        return false;
      }
      this.authService
        .login(this.username, this.password)
        .then((result) => {
          if (!result.data.data) {
            this.$toast.add({
              severity: "error",
              summary: this.$t("messages.error"),
              detail: this.$t("messages.wrongData"),
              life: 3000,
            });
          } else {
            this.setDataUser(result.data.data);
            if (result.data.data.cambiar_password == 1) {
              this.$router.push({ name: "change-password" });
            } else {
              this.$router.push({ name: "informacion" });
            }
          }
          this.loading = false;
        })
        .catch((err) => {
          this.$toast.add({
            severity: "error",
            summary: this.$t("messages.error"),
            detail: this.$t("messages.contactProvider"),
            life: 3000,
          });
          this.loading = false;
          console.log(err);
        });
    },
    solicitarCambio() {
      if (this.email == "" || this.email == null || this.loading) {
        return false;
      }
      this.loading = true;
      this.authService
        .solicitarCambioPassword({ email: this.email })
        .then((result) => {
          if (!result.data.data) {
            this.$toast.add({
              severity: "error",
              summary: this.$t("messages.error"),
              detail: this.$t("messages.passwordRecoveryError"),
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "success",
              summary: this.$t("messages.success"),
              detail: this.$t("messages.passwordRecovery"),
              life: 3000,
            });
            this.solicitarCambioDialog = false
          }
          this.loading = false;
        })
        .catch((err) => {
          this.$toast.add({
            severity: "error",
            summary: this.$t("messages.error"),
            detail: this.$t("messages.passwordRecoveryError"),
            life: 3000,
          });
          this.loading = false;
          console.log(err);
        });
    },
  },
  computed: {
    ...mapGetters([]),
  }
};
</script>

<style scoped>
.nameApp {
  position: absolute;
  margin-top: 20px;
  margin-left: 30px;
  font-size: 1.8rem;
  float: right;
}

.linkResetPassword {
  cursor: pointer;
  color: #2196f3;
  font-size: 12px;
  transition: 0.5s all;
}

.linkResetPassword:hover {
  color: #1768aa;
}

.containerFooter {
  justify-content: space-between !important;
  display: flex !important;
  align-items: flex-end !important;
}
</style>
